export default __webpack_public_path__ + "static/media/cli-alph-resi_minas.7a69590e.jpg";